import FileDownloadComponent from '../../content/components/lesson_components/FileDownloadComponent';
import Grid from '@mui/material/Unstable_Grid2';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import React from 'react';
import Typography from '@mui/material/Typography';
import styles from '../styles/AssetView.module.css';

interface AssetPreviewProps {
  file: File;
  className?: string;
}

export function AssetPreview(props: AssetPreviewProps) {
  const { file, className } = props;
  if (file.type?.startsWith('audio')) {
    return (
      <div className={styles.mediaContainer}>
        <audio
          src={window.URL.createObjectURL(file)}
          controls
          className={className || styles.media}
          onLoad={(e) => window.URL.revokeObjectURL(e.currentTarget.src)} //* free memory
        />
      </div>
    );
  }

  if (file.type.startsWith('image/')) {
    return (
      <div className={styles.mediaContainer}>
        <img
          className={className || styles.media}
          src={window.URL.createObjectURL(file)}
          onLoad={(e) => window.URL.revokeObjectURL(e.currentTarget.src)} //* free memory
        />
      </div>
    );
  }

  if (file.type.startsWith('video/')) {
    return (
      <div className={className || styles.videoContainer}>
        <video
          className={className || styles.video}
          controls
          src={window.URL.createObjectURL(file)}
          onLoad={(e) => window.URL.revokeObjectURL(e.currentTarget.src)} //* free memory
        />
      </div>
    );
  }

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid>
          <InsertDriveFileIcon fontSize="large" />
        </Grid>
        <Grid>
          <Typography variant="caption">{file.name}</Typography>
        </Grid>
        {!className && (
          <FileDownloadComponent
            filename={file.name}
            blob={new Blob([file], { type: file.type })}
          />
        )}
      </Grid>
    </div>
  );
}
